<template>
  <div v-if="visible" class="spinner-container">
    <div class="spinner">
      <img src="@/assets/logo.svg" alt="Logo" class="logo" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Spinner",
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style scoped>
.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.7); /* Dark overlay */
  z-index: 2000;
}

.spinner {
  position: relative;
  width: 80px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.logo {
  width: 40px;
  height: 40px;
  z-index: 1001; /* Ensure logo is above the spinner */
}

.spinner::before {
  content: "";
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 4px solid rgba(0, 0, 0, 0.3);
  border-radius: 50%;
  border-left-color: #ffffff;
  animation: spin 1s linear infinite;
  z-index: 1000; /* Below the logo */
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
